// Day 21 — first priced chase email.

import type { EmailData } from "../../types";
import { longDate } from "../../format";
import { b, body, esc, p } from "../../layouts/chrome";
import { NO_PAYMENT, pricedEmailHtml } from "../../layouts/priced";
import { brand } from "../brand";

export const subject = ({ renewalDate }: EmailData) =>
  `Your ${brand.name} renewal is due on ${longDate(renewalDate)}`;

export const html = (data: EmailData) =>
  pricedEmailHtml({
    brand,
    data,
    callNumber: brand.callNumber,
    quotes: data.quotes ?? [],
    payment: data.payment ?? NO_PAYMENT,
    policyRef: data.policyRef,
    versionRef: data.versionRef,
    bodyHtml: body(
      p(
        `We hope this message finds you well. We are reaching out from ${brand.name} to let you know that your insurance policy for ${b(`'${esc(data.companyName)}' is due for renewal on ${longDate(data.renewalDate)}`)}, and it will ${b("not renew automatically")} — action is needed to stay covered.`,
      ),
      p("To keep your cover uninterrupted, please call our team and we'll take care of the rest."),
    ),
  });
